import { mappingBookingState2RequestDTO } from "../../mapping/mappingBookingState2RequestDTO";

export const getChangeRequestData = ({
  bookingId,
  bookings,
  isEdit,
  isUpgrade,
}: {
  bookingId: string;
  bookings: BookingState[];
  isEdit?: boolean;
  isUpgrade?: boolean;
}): ChangeRequestDTO => {
  return {
    cancelBookingRequest: {
      bookingId,
      bookingDetailIds: (function () {
        const prevIds = bookings
          .flatMap((x) => x.prevBookingState?.childrenLs ?? [])
          .map((x) => x?.product?.id)
          .filter((x) => x);
        const currIds = bookings
          .flatMap((x) => x.childrenLs)
          .map((x) => x?.product?.id)
          .filter((x) => x);
        const ids = prevIds.filter((x) => !currIds.includes(x));
        return bookings
          .flatMap((x) => x.prevBookingState?.childrenLs ?? [])
          .filter((x) => ids.includes(x?.product?.id))
          .map((x) => x?.bookingDetailId)
          .filter(
            (x): x is number | string => x !== undefined && x !== null,
          ) as (number | string)[];
      })(),
      cancelBookingForm: null,
    },
    updateBookingRequest: {
      bookingMetaDataRequest: {
        paymentRequest: null,
        customer: null,
        isSaveBillingAddress: false,
      },
      isEdit,
      isUpgrade,
      bookingRequestList: bookings.map((x) => {
        return mappingBookingState2RequestDTO(x);
      }),
    },
  };
};
